import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from "../market";

const YANDEXMARKET_FAQ = [
  {
    title: "Что такое поведенческий фактор на Яндекс Маркете*?",
    isH3: true,
    text: (
      <p>
        <b> Поведенческий фактор (ПФ)</b> — это совокупность пользовательских действий на маркетплейсе: поиск товара, клики по карточке, изучение описания, добавление в корзину, чтение отзывов и другие активности.
        <br />
        <br />
        Эти данные могут использоваться алгоритмами Яндекс Маркета для анализа интереса к товару и его релевантности запросам пользователей.
      </p>
    ),
  },
  {
    title: "Как происходит продвижение товара на Яндекс Маркете*?",
    isH3: false,
    text:
      <div>
        <b>1. Поисковая оптимизация карточки</b>
        <br />
        <br />
        <ul>
          <li>Ключевые слова: Используйте точные и релевантные фразы в названии, описании и характеристиках.</li>
          <li>Полнота карточки: Загрузите качественные фото, укажите параметры, создайте полезное и понятное описание.</li>
          <li>Отзывы и рейтинг: Призывайте реальных покупателей оставлять обратную связь — это влияет на доверие и кликабельность.</li>
        </ul>
        <br />
        <br />
        <b>2. Коммерческие инструменты</b>
        <br />
        <br />
        <ul>
          <li>Яндекс Директ*: Настройка контекстной рекламы позволяет привлекать трафик по ключевым запросам.</li>
          <li>Скидки и предложения: Акции, кэшбэки и бесплатная доставка повышают привлекательность товара для покупателей.</li>
        </ul>
        <br />
        <br />
        <b>3. Пользовательские сценарии</b>
        <br />
        Дополнительную роль играет органическая активность пользователей. 
        <br />
        Вовлеченность, изучение карточки и взаимодействие с товаром — все это может влиять на позиционирование внутри платформы.
      </div>
  },
  {
    title: "Как Boostclick может помочь в продвижении?",
    isH3: true,
    text:
      <p>
        Платформа Boostclick предоставляет доступ к инструменту формирования пользовательских сценариев. 
        <br />
        Вы настраиваете проект с ключевыми запросами, и исполнители проходят путь покупателя: ищут товар, взаимодействуют с карточкой, изучают описание и характеристики. 
        <br />
        Все действия выполняют реальные пользователи вручную по индивидуальному сценарию.
        <br />
        <br />
        <b>Важно:</b> Boostclick не гарантирует результат в выдаче и не влияет напрямую на алгоритмы Яндекс Маркета*.
        <br />
        Это сервис, с помощью которого вы можете протестировать реакции пользователей на ваш товар.
      </p>
  },
  {
    title: "Когда можно ожидать первые результаты?",
    isH3: true,
    text:
      <p>
        Изменения в показателях вовлеченности можно увидеть в течение нескольких дней после начала проекта. 
        <br />
        Однако стабильный рост позиций зависит от множества факторов: от уровня конкуренции до качества карточки и внутренних алгоритмов Яндекс Маркета*.
      </p>
  },
  {
    title: "Почему важно контролировать исполнителей?",
    isH3: false,
    text:
      <p>
        Поскольку задания выполняются реальными людьми, важно контролировать качество выполнения. 
        <br />
        Boostclick предоставляет инструменты модерации и отчеты, которые помогают отслеживать корректность действий.
        <br />
        Это обеспечивает прозрачность и эффективность тестируемых сценариев.
        <br />
        <br />
        <b>Совет:</b> Настраивая продвижение, ориентируйтесь не только на активность, но и на общее качество карточки. 
        <br />
        Поведенческие сценарии — это вспомогательный инструмент анализа и взаимодействия, но не замена полноценной маркетинговой стратегии.
      </p>
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска товара по сделанному
    скриншоту вашей ссылки.
  </p>
);

const REVIEW_PRICE = 250;

const ACTIONS = [
  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить товар в избранное",
    initialShare: 0.5,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.BUSKET",
    icon: "busket",
    iconHome: "home-busket",
    title: "Добавить товар в корзину",
    initialShare: 0.1,
    activityType: 'Корзина',
  },
  {
    type: "MAIN.BUY",
    icon: "busket",
    iconHome: "home-busket",
    title: "Нажать «Купить сейчас»",
    initialShare: 0.2,
    activityType: 'Корзина',
  },
  {
    type: "MAIN.LIKE",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить лайк на последний отзыв",
    initialShare: 0.1,
    activityType: 'Лайк',
  },

  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение Яндекс Маркет",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти товар через поиск Яндекс Маркета",
    initialShare: 1,
  },
  {
    type: 'ALWAYS.COMPETITORS',
    icon: "time",
    iconHome: "home-time",
    title: 'Быстро посмотреть конкурентов',
    initialShare: 1,
  },
  {
    type: "ALWAYS.CLICK",
    icon: "click",
    iconHome: "home-click",
    title: "Зайти на карточку товара",
    initialShare: 1,
  },

  {
    type: "EXTRA.MEDIA",
    icon: "eye",
    iconHome: "home-eye",
    title: "Посмотреть все фото и видео на карточке",
    initialShare: 0.6,
  },
  {
    type: "EXTRA.DESCRIPTION",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать полное описание товара",
    initialShare: 0.2,
  },
  {
    type: "EXTRA.GOODS",
    icon: "click",
    iconHome: "home-click",
    title: "Нажать кнопку «Все товары продавца»",
    initialShare: 0.1,
  },
  {
    type: "EXTRA.FEEDBACKS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать отзывы на товар",
    initialShare: 0.1,
  },

  {
    type: "MAIN.THUMBSUP",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить палец вверх на последний вопрос о товаре",
    initialShare: 0.1,
    activityType: 'Лайк',
  },
  {
    type: "MAIN.DISLIKE",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Поставить дизлайк на последний вопрос о товаре",
    initialShare: 0,
    activityType: 'Дизлайк',
    hidden: true,
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    titleComment: "Изучение товаров",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-star",
    title: "Добавить в избранное",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "Добавить в корзину",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "Купить сейчас",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Оценить отзыв",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти товар",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть сайт или приложение",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Посмотреть конкурентов",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Карточка товара",
    path: "/povedencheskie-faktory-na-yandexmarket",
    target: '_self',
  }
];

const STEP_PHRASE_2 = "Укажите информацию для поиска товара";

const YANDEXMARKET_KEYWORDS = [
  'Yandex Market', 'yandex market', 'Яндекс Маркет', 'яндекс маркет', 'ям', 'zv'
];

class YandexMarketClass extends Market {
  id = "yandexmarket";
  host = "market.yandex.ru";
  url = "https://market.yandex.ru/";

  title = "Яндекс.Маркет*";

  isMarketplace = true;

  icon = "yandexmarket";
  titlePlaces = "Яндекс.Маркет*";
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { type: "Одежда и обувь" },
    { type: "Дом" },
    { type: "Детские товары" },
    { type: "Красота" },
    { type: "Электроника" },
    { type: "Бытовая техника" },
    { type: "Цветы" },
    { type: "Дача и сад" },
    { type: "Продукты питания" },
    { type: "Строительство и ремонт" },
    { type: "Мебель" },
    { type: "Автотовары" },
    { type: "Аптека" },
    { type: "Спорт и отдых" },
    { type: "Товары ИКЕА" },
    { type: "Ювелирные украшения" },
    { type: "Книги" },
    { type: "Хобби и творчество" },
    { type: "Досуг и развлечения" },
    { type: "Для школы и офиса" },
    { type: "Ноутбуки и компьютеры" },
    { type: "Все для гейминга" },
    { type: "Умные колонки" },
    { type: "Гигиена" },
    { type: "Бытовая химия" },
    { type: "Зоотовары" },
    { type: "Оптика" },
    { type: "Ремесла" },
    { type: "Цифровые товары" },
    { type: "Оборудование" },
    { type: "Уценка" },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = YANDEXMARKET_KEYWORDS;

  targetLinkComment = "Укажите тут адрес вашего товара на Яндекс Маркете*";
  targetLinkCommentShort = "Укажите ссылку товара";

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: "/povedencheskie-faktory-na-yandexmarket",
      rating: 0.7,
      title: "ПФ",
      navigateTitle: "Поведение и тест карточек товаров",
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: "Накрутка ПФ ЛЮДИ на Яндекс Маркете — от 1.9 руб. | Boostclick",
        description: "Накрутка ПФ ЛЮДИ на Яндекс Маркете — просмотры, добавления.",
        canonical: '/povedencheskie-faktory-na-yandexmarket',
      },
      intro: {
        title: "Тестирование и анализ пользовательского поведения на Яндекс Маркете*",
        comment: 'Через микрозадачи и действия реальных пользователей',
        points: [
          'Без ботов и автоматизации',
          'Без самовыкупов и искусственных заказов',
          'Только уникальные реальные пользователи',
          'Индивидуальные задания и сценарии',
          'Подробные отчеты с результатами',
          'Поиск магазина по ключевым фразам через органику Яндекс Маркета*',
          'Соблюдение сроков и прозрачность взаимодействия',
        ],
      },
      howItWorks: [
        /* "Настройте параметры активности в соответствии с конкуренцией",
        "Укажите ссылку на товар для скриншота",
        "Укажите категорию, город и ключевые фразы из карточки товара",
        "После оплаты мы передадим исполнителю скриншот и параметры для поиска",
        "Проверьте ответы и активность, примите работу или отправьте на доработку", */
      ],
      stepPhrase1: "Настройка пользовательских сценариев на Яндекс Маркете*",
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: "Продвижение и улучшение карточек на Яндекс Маркете*",
      titleFAQ: "Вопрос-ответ: Поведенческие сценарии и продвижение на Яндекс Маркете*",
      faq: YANDEXMARKET_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(
            (action) =>
              action.type !== "MAIN.REVIEW" && !action.type.startsWith("VIEW.")
          ),
          ...ACTIONS.filter((action) => action.type === "MAIN.REVIEW"),
        ];
      })(),
      notice: [
        'Платформа Boostclick позволяет моделировать пользовательские сценарии, основанные на органическом поиске и действиях реальных людей.',
        'Каждое задание включает цепочку шагов:',
        '– Поиск магазина или товара по ключевому запросу',
        '– Изучение карточек, характеристик, отзывов',
        '– Взаимодействие (добавление в избранное, корзину и др.)',
        'Цепочки формируются индивидуально и соответствуют вашему запросу. Сложность и продолжительность зависят от объема сценариев в проекте.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на товар';
  invalidUrlStr = 'Укажите корректную ссылку на товар';
}

const YandexMarket = new YandexMarketClass();
export default YandexMarket;
